import { GridRightClickMenuModule } from './grid-right-click-menu/grid-right-click-menu.module';
import { KendoDataSourceMvcDirective } from './kendo-data-source-mvc';
import { KendoGridStateDirective } from './kendo-grid-state/kendo-grid-state.directive';
import { NgModule } from '@angular/core';

/**
 * Module providing essential grid components for data list pages.
 * 
 * This module bundles commonly used grid functionality including context menus,
 * state persistence, and server-side data operations. It's designed to be imported
 * in list pages that use Kendo UI Grid components.
 * 
 * @example
 * ```typescript
 * import { GridListImportsModule } from '@ticomix/angular-kendo';
 * 
 * @NgModule({
 *   imports: [GridListImportsModule]
 * })
 * export class MyListModule { }
 * ```
 */
@NgModule({
  imports: [
    GridRightClickMenuModule,
    KendoGridStateDirective,
    KendoDataSourceMvcDirective
  ],
  exports: [
    GridRightClickMenuModule,
    KendoGridStateDirective,
    KendoDataSourceMvcDirective
  ]
})
export class GridListImportsModule { }